import { Accordion, Button } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { useNavbarShallowStore } from "../../../store";
import { Info, PanelLeft, TriangleAlert } from "lucide-react";
import { PAGE_HEADER_SIZE_STRING } from "../../../constants/header-sizing";
import { useAuth } from "@tellescope/tanstack-query";
import { EmailDomainBlock } from "./EmailDomainBlock";

export const EmailSettingsPage = () => {
  const { t } = useTranslation("settings");
  const { selectedOrganization } = useAuth();
  const { isCollapsed, toggleCollapsed } = useNavbarShallowStore("isCollapsed", "toggleCollapsed");

  return (
    <>
      <section
        style={{
          minHeight: PAGE_HEADER_SIZE_STRING,
          height: PAGE_HEADER_SIZE_STRING,
        }}
        className="flex items-center pl-2 w-full border-b border-b-gray-200 flex-shrink-0"
      >
        <Button
          variant="ghost"
          size="icon"
          className="w-9 h-9 rounded-md shrink-0"
          onClick={toggleCollapsed}
          title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <PanelLeft className="h-5 w-5" />
        </Button>
      </section>
      <section className="border-b px-6 py-6 space-y-2">
        <h1 className="text-3xl leading-9 text-gray-950 font-semibold">{t("Email Settings")}</h1>
        <h4 className="text-muted-foreground">{t("Configure email notifications and preferences")}</h4>
      </section>
      <section className="p-6 space-y-4">
        <div className="border rounded-sm flex gap-3 p-3">
          <Info size={20} className="text-gray-800 p-0.5 shrink-0" />
          <p className="text-sm">
            {t(
              "Add the following DNS records to your domain to complete verification. DKIM verification may take up to 72 hours after DNS records are added."
            )}
          </p>
        </div>
        <div className="border rounded-sm flex gap-3 p-3 border-yellow-200 bg-yellow-50 text-yellow-900">
          <TriangleAlert size={20} className="text-yellow-900 p-0.5 shrink-0" />
          <p className="text-sm">
            <span className="font-semibold">{t("Note: ")}</span>
            {t(
              'Some DNS providers automatically append your root domain to record names. If your provider does this, omit the ".tellescope.co" suffix from the Name values below to avoid duplicates like "token._domainkey.tellescope.co.tellescope.co".'
            )}
          </p>
        </div>
        <Accordion type="multiple">
          {selectedOrganization?.verifiedEmailDomains?.map((domain) => (
            <EmailDomainBlock key={domain.domain} domain={domain} />
          ))}
        </Accordion>
      </section>
    </>
  );
};
